import React, { useState, useRef, useEffect, useCallback } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import PaymentTermsFilter from "./PaymentTermsFilter";
import AgGridTable from "../../utilities/AgGridTable";
import PaymentTermsForm from "./PaymentTermsForm";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { confirmAlert } from "react-confirm-alert";
import { Button, IconButton, Tooltip } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';

const EditRenderer = (props) => {
  return (
    <span>
      <IconButton onClick={() => props.handleEditDialogOpen(props.data)}>
        <FuseSvgIcon size={18} color="action">
          heroicons-outline:pencil
        </FuseSvgIcon>
      </IconButton>
      <IconButton onClick={() => props.handleViewDialogOpen(props.data)}>
        <FuseSvgIcon size={18} color="action">
          heroicons-outline:document-search
        </FuseSvgIcon>
      </IconButton>
    </span>
  );
};

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.paymentTerms}`;

const PaymentTerms = () => {
  const [addOpen, setAddOpen] = useState(false);
  const [editRowOpen, setEditRowOpen] = useState(false);
  const [viewRowOpen, setViewRowOpen] = useState(false);
  const [viewRowMainOpen, setViewRowMainOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const perPage = 10;
  const [gridApi, setGridApi] = useState(null);
  const [error, setError] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState(false);
  const [addRow, setAddRow] = useState([]);
  const [editRow, setEditRow] = useState([]);
  const [viewRow, setViewRow] = useState([]);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [checkSubmit, setCheckSubmit] = useState(false);
  const handleViewDialogOpen = (event) => {
    setViewRowOpen(true);
    setViewRow(event);
  };
  const handleEditDialogOpen = (event) => {
    setEditRowOpen(true);
    setEditRow(event);
  };
  const [columnDefs, setColumnDefs] = useState([
    { field: "code", maxWidth: 130, editable: false, enableRowGroup: true },
    { field: "paymentCondition", editable: false, enableRowGroup: true },
    // {
    //   headerName: "Action",
    //   cellRenderer: (data) => (
    //     <EditRenderer
    //       data={data}
    //       handleEditDialogOpen={handleEditDialogOpen}
    //       handleViewDialogOpen={handleViewDialogOpen}
    //     />
    //   ),
    //   maxWidth: 150,
    // },
  ]);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(`${url}?size=1000`);
      let data = list.data?._embedded?.paymentTerms;
      console.log(data);
      setRowData(data);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const handleAddButton = (event) => {
    setAddOpen(true);
    setAddRow(event);
  };

  const handleClose = () => {
    setAddOpen(false);
    setEditRowOpen(false);
    setViewRowOpen(false);
    setViewRowMainOpen(false);
  };

  const getContextMenuItems = (event) => {
    var result = [
      {
        name: "Add",
        icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
        action: () => {
          handleAddDialogOpen(event);
        },
      },
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: () => {
          handleEditDialogOpen(event);
        },
      },
      {
        name: "View",
        icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
        action: () => {
          handleViewDialogOpen(event);
        },
      },
      {
        name: "Delete",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          handleDelete(event);
        },
      },
    ];
    return result;
  };

  // const handleSearchCode = useCallback((codeValue) => {
  //   var countryFilterComponent = gridRef.current.api.getFilterInstance("code");
  //   if(codeValue !== '') {
  //     countryFilterComponent.setModel({ values: [codeValue] });
  //   } else {
  //     countryFilterComponent.setModel(null);
  //   }
  //   gridRef.current.api.onFilterChanged();
  // }, []);

  // const handleSearchCondition = useCallback((paymentConditionValue) => {
  //   var ageFilterComponent = gridRef.current.api.getFilterInstance("paymentCondition");
  //   if(paymentConditionValue !== '') {
  //     ageFilterComponent.setModel({values: [paymentConditionValue]});
  //   } else {
  //     ageFilterComponent.setModel(null);
  //   }
  //   gridRef.current.api.onFilterChanged();
  // }, []);

  const handleSearch = useCallback((paymentConditionValue) => {
    gridRef.current.api.setQuickFilter(paymentConditionValue);
  }, []);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "PaymentTerms.xlsx",
      sheetName: "Payment Terms",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const handleAdd = async (event, values, formValues) => {
    // setCheckSubmit(true);
    const find = rowData?.find(item=>item.code === values.code)
    if(find) {
      toast.error("Provided Code already exist into the system");
    } else {
      const newRow = {
        code: values.code,
        paymentCondition: values.paymentCondition,
        paymentInstallmentList: formValues.map((item) => ({
          ...item,
          type: item.type.value || item.type,
        })),
      };
      await OAuthService.addData(url, newRow);
      loadData();
      toast.success("Data saved Successfully")
      handleClose()
    }
  };

  const handleEdit = async (event, values, formValues) => {
    const code = event?.node?.data?.code;
    const id = event?.node?.data?.id;
    const editRow = {
      code: values.code,
      paymentCondition: values.paymentCondition,
      paymentInstallmentList: formValues.map((item) => ({
        ...item,
        type: item.type.value || item.type,
      })),
    };
    if(values.code === code){
      try {
        if (id) {
          await OAuthService.putData(`${url}/${id}`, editRow);
          loadData();
          toast.success("Data Updated Successfully")
        }
      } catch (error) {
        setError(error.message);
        return;
      }
      handleClose()
    }else{
      const find = rowData?.find(item=>item.code === values.code)
      if(find){
        toast.error("Provided Code already exist into the system");
      }else{
        try {
          if (id) {
            await OAuthService.putData(`${url}/${id}`, editRow);
            loadData();
            toast.success("Data Updated Successfully")
          }
        } catch (error) {
          setError(error.message);
          return;
        }
        handleClose()
      }
    }
  };

  const handleDelete = useCallback(
    (event) => {
      const selectedRow = [event.node.data];

      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to delete.",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              rowData.splice(event.node.rowIndex, 1);
              gridRef?.current?.api.applyTransaction({ remove: selectedRow });
              selectedRow.map(async (row) => {
                const id = row?.id;
                await OAuthService.deleteData(url, id);
                setSuccessMsg("Data deleted Successfully");
                setSnackState(true);
              });
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [gridRef, rowData]
  );

  const handleAddNewRow = async (values, startDate, endDate) => {
    const payload = {
      period: values.period,
      year: values.year,
      startDate: startDate,
      endDate: endDate,
      postingAllowed: values.postingAllowed,
      availableInventory: values.availableInventory,
      pricingAllowed: values.pricingAllowed,
      resetAllowed: values.resetAllowed,
    };
    await OAuthService.addData(url, payload);
    loadData();
    setSuccessMsg("Data saved Successfully");
    setSnackState(true);
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const onRowDoubleClicked = (params) => {
    handleEditDialogOpen(params);
  };

  const handlePurge = () => {
    selectedRows.map(async (row) => {
      const id = row?.id;
      try {
        await OAuthService.deleteData(url, id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
        loadData();
      } catch (error) {
        setError(error.message);
      }
    });
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false);
    } else {
      setDeleteDisable(true);
    }
  }, [selectedRows]);

  const paymentInputFields = () => {
    return (
      <>
        <Tooltip title={"Link to Partner"}>
          <Link to={"/linkToCustomer"}>
            <Button
              variant="contained"
              color="warning"
              style={{ marginLeft: "4px" }}
              // onClick={handleSubmit}
            >
              <FuseSvgIcon>material-solid:manage_accounts</FuseSvgIcon>
            </Button>
          </Link>
        </Tooltip>
      </>
    );
  };

  return (
    <>
      <ListPageHeader
        componentName="Payment Terms"
        onBtExport={onBtExport}
        handlePurge={handlePurge}
        handleAddButton={handleAddButton}
        deleteDisable={deleteDisable}
        pageName="Payment Terms"
        error={error}
        successMsg={successMsg}
        gridRef={gridRef}
        snackState={snackState}
        showPaginationDropdown={showPaginationDropdown}
        headerInputFields={paymentInputFields()}
      />
      {/* <PaymentTermsFilter handleSearch={handleSearch} handleAddDialogOpen={handleAddButton} /> */}
      <div className="h-full">
        <AgGridTable
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowData={rowData}
          // paginationPageSize={perPage}
          // cacheBlockSize={perPage}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          // getContextMenuItems={getContextMenuItems}
          editable={false}
          // pagination={false}
        />
      </div>
      <PaymentTermsForm
        addOpen={addOpen}
        editRowOpen={editRowOpen}
        viewRowOpen={viewRowOpen}
        // viewRowMainOpen={viewRowMainOpen}
        handleClose={handleClose}
        handleAdd={handleAdd}
        handleEdit={handleEdit}
        addRow={addRow}
        editRow={editRow}
        viewRow={viewRow}
        // checkSubmit={checkSubmit}
        // handleDelete={handleDelete}
        // handleAddNewRow={handleAddNewRow}
      />
    </>
  );
};

export default PaymentTerms;
